import { Component, Inject, Injector, OnInit, ChangeDetectionStrategy } from "@angular/core";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import {
    FormComponent,
    IFormDialogData,
} from "src/app/shared/form/form.component";
import { SegService } from "src/app/services/seg.service";
import { SEG } from "src/app/models/seg.model";
import {
    HierarchicalSelectionFormField,
    TextAreaFormField,
    TextFormField,
} from "src/app/shared/form/formField.model";
import nameOf from "src/app/shared/form/nameOf.helper";
import { forkJoin } from "rxjs";
import { OrganizationLevelService } from "src/app/services/organizationLevel.service";
import { toOrganizationTree } from "src/app/_helpers/org-tree-helper";
import { OrganizationLevel } from "src/app/models/organizationLevel.model";
import { OperatorTypeEnum } from "src/app/enums/operatorType.enum";
import { OrgLevelTypeEnum } from "src/app/enums/orgLevelType.enum";

@Component({
  standalone: false,
    selector: "app-seg-dialog",
    templateUrl: "./../../shared/form/form.component.html",
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrls: ["./../../shared/form/form.component.scss"],
})
export class SegDialogComponent extends FormComponent<SEG> implements OnInit {
    organizationLevels: OrganizationLevel[];
    constructor(
        dialogRef: MatDialogRef<SegDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public data: IFormDialogData,
        segService: SegService,
        private organizationLevelService: OrganizationLevelService,
        protected injector: Injector,
    ) {
        super(dialogRef, segService, data, "SEG", injector);
    }

    ngOnInit(): void {
        this.isFormLoading = true;
        const orgPayload = JSON.stringify({
            OperatorTypeEnum: JSON.stringify({
                Condition: OperatorTypeEnum.Equal,
                Field: nameOf<OrganizationLevel>((x) => x.orgLevelType),
                Value: `${OrgLevelTypeEnum.Site},${OrgLevelTypeEnum.Function},${OrgLevelTypeEnum.BusinessUnit},${OrgLevelTypeEnum.Corporate}`,
            }),
        });
        forkJoin({
            entity: this.getEntity(),
            organizationLevels:
                this.organizationLevelService.getAll(orgPayload),
        }).subscribe(
            (result) => {
                this.entity = result.entity;
                this.organizationLevels = result.organizationLevels;
                this.initFields();
                this.isFormLoading = false;
            },
            (error) => {
                this.toastService.showError(error);
                this.isFormLoading = false;
            },
        );
    }

    getNewObject(): SEG {
        return new SEG();
    }

    validate(): boolean {
        return true;
    }

    initFields(): void {
        this.fields = [
            new TextFormField({
                property: nameOf<SEG>((x) => x.name),
                name: "SEG Name",
            }),
            new HierarchicalSelectionFormField({
                property: nameOf<SEG>((x) => x.organizationLevelId),
                name: "Organization Level",
                options: toOrganizationTree(this.organizationLevels),
                required: true,
            }),
            new TextFormField({
                property: nameOf<SEG>((x) => x.code),
                name: "Code",
                required: true,
            }),
            new TextAreaFormField({
                property: nameOf<SEG>((x) => x.description),
                name: "Description",
                required: false,
            }),
        ];
    }
}
